(function () {
  'use strict';

  // ============================================================
  //  i18n bridge — reads the JSON island emitted by Liquid
  //  Decodes HTML entities (Shopify's t-filter escapes ' " & < >).
  // ============================================================
  function decodeEntities(s) {
    if (typeof s !== 'string') return s;
    return s
      .replace(/&#39;/g, "'")
      .replace(/&#34;/g, '"')
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&nbsp;/g, ' ');
  }
  function deepDecode(v) {
    if (typeof v === 'string') return decodeEntities(v);
    if (Array.isArray(v)) return v.map(deepDecode);
    if (v && typeof v === 'object') {
      const out = {};
      for (const k of Object.keys(v)) out[k] = deepDecode(v[k]);
      return out;
    }
    return v;
  }

  let __ymI18nTree = {};
  try {
    const el = document.getElementById('ym-quiz-i18n');
    if (el) __ymI18nTree = deepDecode(JSON.parse(el.textContent || '{}'));
  } catch (e) {}

  window.__ymI18n = function (key, fallback) {
    const parts = key.replace(/^quiz\./, '').split('.');
    let cur = __ymI18nTree;
    for (const p of parts) {
      if (cur == null || typeof cur !== 'object') return fallback;
      cur = cur[p];
    }
    return (typeof cur === 'string') ? cur : fallback;
  };

  window.__ymTree = function (key) {
    const parts = key.replace(/^quiz\./, '').split('.');
    let cur = __ymI18nTree;
    for (const p of parts) {
      if (cur == null || typeof cur !== 'object') return null;
      cur = cur[p];
    }
    return cur;
  };

  // ============================================================
  //  Hardcoded per-locale lists (styles, voices, occasions)
  //  These come from the design spec — kept here because Shopify
  //  locale files cannot store arrays as leaf values.
  // ============================================================
  const LISTS = {
    fr: {
      styles: [
        "Variété française", "Surprenez-moi", "Ballade romantique", "Piano",
        "Country", "Pop", "R&B", "Rap", "Rock", "Autre (Précisez plus bas)",
        "Ouverture de bal / Mariage", "Oriental", "Latino", "Afro beats",
        "Métal", "Soul", "Reggae", "Disco", "Classique", "Orchestre"
      ],
      voices: ["Chanteuse", "Chanteur", "Surprenez-moi"],
      occasions: [
        "Anniversaire", "Mariage", "Saint-Valentin", "Fête des Mères",
        "Fête des Pères", "Naissance", "Noël", "Demande en mariage",
        "Anniversaire de mariage", "Juste parce que", "Autre"
      ]
    },
    en: {
      styles: [
        "Surprise Me", "Indie", "Romantic Ballad", "Piano", "Country", "Folk",
        "R&B", "Pop", "Rap / Hip-Hop", "Rock", "Blues", "Other (Specify below)",
        "First Dance / Wedding", "Gospel", "Oriental", "Latin", "Afro Beats",
        "Metal", "Soul", "Reggae", "Disco", "Classical", "Orchestra"
      ],
      voices: ["Female singer", "Male singer", "Surprise me"],
      occasions: [
        "Birthday", "Wedding", "Valentine's Day", "Mother's Day", "Father's Day",
        "Birth", "Christmas", "Proposal", "Wedding Anniversary", "Just because", "Other"
      ]
    },
    de: {
      styles: [
        "Überrasche mich", "Schlager", "Deutschpop", "Romantische Ballade",
        "Rock-Folk", "Klavier", "Pop", "Country", "R&B", "Rap", "Rock",
        "Alternative Rock", "Andere (unten angeben)", "Eröffnungstanz / Hochzeit",
        "Orientalisch", "Latino", "Afrobeats", "Metal", "Soul", "Reggae",
        "Disco", "Klassik", "Orchester"
      ],
      voices: ["Sängerin", "Sänger", "Überrasche mich"],
      occasions: [
        "Geburtstag", "Hochzeit", "Valentinstag", "Muttertag", "Vatertag",
        "Geburt", "Weihnachten", "Heiratsantrag", "Hochzeitstag", "Einfach so", "Andere"
      ]
    }
  };

  // ============================================================
  //  Line item property labels per locale
  //  (visible to customer in cart/checkout AND to merchant in admin)
  // ============================================================
  const PROP_LABELS = {
    fr: {
      recipient: 'Pour qui',
      firstName: 'Prénom',
      style: 'Style',
      voice: 'Voix',
      occasion: 'Occasion',
      qualities: 'Qualités',
      memories: 'Souvenirs',
      difficulties: 'Difficultés',
      message: 'Message',
      songTitle: 'Titre de la chanson',
      artist: 'Artiste',
      socle: 'Socle',
      yes: 'Oui'
    },
    en: {
      recipient: 'For whom',
      firstName: 'First name',
      style: 'Music style',
      voice: 'Voice',
      occasion: 'Occasion',
      qualities: 'Qualities',
      memories: 'Memories',
      difficulties: 'Hard times',
      message: 'Message',
      songTitle: 'Song title',
      artist: 'Artist',
      socle: 'Wooden base',
      yes: 'Yes'
    },
    de: {
      recipient: 'Für wen',
      firstName: 'Vorname',
      style: 'Musikstil',
      voice: 'Stimme',
      occasion: 'Anlass',
      qualities: 'Eigenschaften',
      memories: 'Erinnerungen',
      difficulties: 'Schwere Zeiten',
      message: 'Botschaft',
      songTitle: 'Liedtitel',
      artist: 'Künstler',
      socle: 'Holzsockel',
      yes: 'Ja'
    }
  };

  // ============================================================
  //  State machine
  // ============================================================
  const STORAGE_KEY = 'ym_quiz_state_v1';
  const STATE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

  const STEPS = [
    'step-1', 'step-2', 'step-3',
    'step-4', 'step-5', 'step-6', 'step-7',
    'upsell-1', 'upsell-2'
  ];

  const RECIPIENT_KEYS = [
    'husband','wife','child','mother','father',
    'girlfriend','boyfriend','sibling','friend','self','other'
  ];

  function emptyAnswers() {
    return {
      recipient: null,
      recipientOther: '',
      recipientName: '',
      musicStyle: null,
      musicStyleOther: '',
      voice: null,
      occasion: null,
      occasionOther: '',
      qualities: '',
      memories: '',
      difficulties: '',
      message: '',
      upsell1: { product: null, socle: false, songTitle: '', artist: '', photoMeta: null },
      upsell2: { delivery: 'standard', streaming: false }
    };
  }

  /** HTML-escape user-controlled strings before inserting into innerHTML. */
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /** Sanitize free-text before it becomes a line-item property. Those values
   *  travel order → Make → the full-song Suno POST body, which is assembled as
   *  a raw JSON string (no auto-escaping). A stray backslash or double-quote in
   *  a name/message terminates/escapes the JSON literal and breaks the request
   *  ("Expected ',' or '}' ... at position N") with no way to recover. So we
   *  drop those two characters and collapse line breaks before sending. */
  function flatten(s) {
    return String(s == null ? '' : s)
      .replace(/[\r\n]+/g, '. ')   // line breaks → period+space
      .replace(/\s+/g, ' ')        // collapse runs of whitespace
      .replace(/\\/g, '')          // drop backslashes (would escape the next char)
      .replace(/"/g, "'")          // double quotes → single (safe inside JSON literals)
      .trim();
  }

  /** Robust "is this an 'Other' option?" check across FR/EN/DE. */
  function isOtherValue(v) {
    return !!v && /\b(autre|other|andere|précisez|specify|unten)\b/i.test(v);
  }

  class YMQuiz {
    constructor(root) {
      this.root = root;
      this.locale = (root.dataset.locale || 'fr').toLowerCase();
      // Normalize locale to one of fr/en/de for list lookups
      this.listLocale = this.locale.startsWith('en') ? 'en'
                      : this.locale.startsWith('de') ? 'de' : 'fr';
      try { this.variants = JSON.parse(root.dataset.variants || '{}'); }
      catch (e) { this.variants = {}; }
      this.images = {
        plaque: { fr: root.dataset.imgPlaqueFr, en: root.dataset.imgPlaqueEn, de: root.dataset.imgPlaqueDe },
        magnet: { fr: root.dataset.imgMagnetFr, en: root.dataset.imgMagnetEn, de: root.dataset.imgMagnetDe }
      };
      this.currentStep = STEPS[0];
      this.answers = emptyAnswers();
      this.photoFile = null;

      // Prices emitted by Liquid (already localized to the customer's currency)
      this.prices = {};
      try {
        const pEl = document.getElementById('ym-prices-source');
        if (pEl) this.prices = JSON.parse(pEl.textContent || '{}');
      } catch (e) {}

      // Track which steps have been "arrived on" this session, so we don't double-fire on back/forward
      this.trackedSteps = new Set();

      this.els = {
        progress: root.querySelector('.ym-quiz__progress'),
        stepLabel: root.querySelector('[data-ym="step-label"]'),
        stepTitle: root.querySelector('[data-ym="step-title"]'),
        stepSubtitle: root.querySelector('[data-ym="step-subtitle"]'),
        stepContent: root.querySelector('[data-ym="step-content"]'),
        btnBack: root.querySelector('[data-ym="back"]'),
        btnNext: root.querySelector('[data-ym="next"]')
      };
    }

    save() {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
          v: 1, lastUpdated: Date.now(), locale: this.locale,
          step: this.currentStep, answers: this.answers
        }));
      } catch (e) {}
    }
    load() {
      try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        const data = JSON.parse(raw);
        if (data.v !== 1) return false;
        if (Date.now() - (data.lastUpdated || 0) > STATE_TTL_MS) return false;
        this.answers = Object.assign(emptyAnswers(), data.answers || {});
        if (data.answers && data.answers.upsell1) {
          this.answers.upsell1 = Object.assign(emptyAnswers().upsell1, data.answers.upsell1);
        }
        if (data.answers && data.answers.upsell2) {
          this.answers.upsell2 = Object.assign(emptyAnswers().upsell2, data.answers.upsell2);
        }
        this.currentStep = STEPS.includes(data.step) ? data.step : STEPS[0];
        return true;
      } catch (e) { return false; }
    }
    clear() {
      try { window.localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      this.answers = emptyAnswers();
      this.photoFile = null;
      this.currentStep = STEPS[0];
    }
    stepIndex() { return STEPS.indexOf(this.currentStep); }

    /** Fire a tracking event to fbq + dataLayer. Errors are swallowed (adblockers etc.). */
    track(eventName, payload) {
      const data = Object.assign({ locale: this.locale, step: this.currentStep }, payload || {});
      try { if (window.fbq) window.fbq('trackCustom', eventName, data); } catch (e) {}
      try { if (window.gtag) window.gtag('event', eventName, data); } catch (e) {}
      try {
        if (window.dataLayer && window.dataLayer.push) {
          window.dataLayer.push(Object.assign({ event: 'ym_' + eventName.toLowerCase() }, data));
        }
      } catch (e) {}
    }

    /** Fire arrival event for a step. Each step fires at most once per session
     *  (so back/forward doesn't double-count and skew the funnel). */
    trackArrival(step) {
      if (this.trackedSteps.has(step)) return;
      this.trackedSteps.add(step);
      const eventMap = {
        'step-1':   'QuizStarted',
        'step-2':   'QuizStep2',
        'step-3':   'QuizStep3',
        'step-4':   'QuizStep4',
        'step-5':   'QuizStep5',
        'step-6':   'QuizStep6',
        'step-7':   'QuizStep7',
        'upsell-1': 'QuizUpsell1',
        'upsell-2': 'QuizUpsell2'
      };
      if (eventMap[step]) this.track(eventMap[step]);
    }

    goto(step, opts) {
      if (!STEPS.includes(step)) return;
      this.currentStep = step;
      this.save();
      this.render();
      if (!opts || !opts.silent) {
        const hash = '#' + step;
        if (window.location.hash !== hash) window.location.hash = hash;
      }
      // Scroll the quiz section to the top of the viewport so the new step is visible
      this.scrollToQuizTop();
      this.trackArrival(step);
    }

    /** Scroll viewport so the quiz progress bar is just below the site header.
     *  Respects prefers-reduced-motion. */
    scrollToQuizTop() {
      const anchor = this.els.progress || this.root;
      if (!anchor) return;
      const rect = anchor.getBoundingClientRect();
      // Aim for the anchor to be ~24px from the top of the viewport (leaves a little breathing room)
      const targetY = window.pageYOffset + rect.top - 24;
      const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try {
        window.scrollTo({ top: Math.max(0, targetY), behavior: reducedMotion ? 'auto' : 'smooth' });
      } catch (e) {
        // Older browsers without scroll options
        window.scrollTo(0, Math.max(0, targetY));
      }
    }
    next() {
      const i = this.stepIndex();
      if (i < STEPS.length - 1) {
        this.goto(STEPS[i + 1]);
      } else {
        this.submit();
      }
    }
    back() {
      const i = this.stepIndex();
      if (i > 0) this.goto(STEPS[i - 1]);
    }

    // ============================================================
    //  Render
    // ============================================================
    render() {
      const i = this.stepIndex();

      // Progress dots
      if (this.els.progress) {
        Array.from(this.els.progress.children).forEach((dot, idx) => {
          dot.className = 'ym-quiz__progress-dot';
          if (idx < i) dot.classList.add('ym-quiz__progress-dot--done');
          if (idx === i) dot.classList.add('ym-quiz__progress-dot--active');
        });
      }

      // Back hidden on Step 1 only
      this.els.btnBack.hidden = (i === 0);

      // Next label
      const nextLabel = this.els.btnNext.querySelector('span:not([aria-hidden])');
      if (nextLabel) {
        nextLabel.textContent = (i === STEPS.length - 1)
          ? window.__ymI18n('quiz.buttons.order', '🔒 Commander votre chanson')
          : window.__ymI18n('quiz.buttons.next', 'Continuer');
      }

      // Step label (top)
      if (i < 7) {
        const tpl = window.__ymI18n('quiz.labels.step_of', 'Étape {{ current }} sur 7');
        this.els.stepLabel.textContent = tpl.replace('{{ current }}', String(i + 1));
      } else if (i === 7) {
        this.els.stepLabel.textContent = window.__ymI18n('quiz.labels.upsell_label', 'Personnalisez votre cadeau');
      } else {
        this.els.stepLabel.textContent = window.__ymI18n('quiz.labels.final_label', 'Dernière étape');
      }

      // Title + subtitle from i18n
      const stepKey = this.currentStep.replace('-', '');
      this.els.stepTitle.textContent = window.__ymI18n('quiz.' + stepKey + '.title', '');
      this.els.stepSubtitle.textContent = window.__ymI18n('quiz.' + stepKey + '.subtitle', '');

      // Body
      this.renderStepBody();
      this.updateNextEnabled();
    }

    renderStepBody() {
      this.els.stepContent.innerHTML = this.stepBodyHTML(this.currentStep);

      // Mount sessions widget + app blocks for upsell-2
      if (this.currentStep === 'upsell-2') {
        const sessionsMount = this.els.stepContent.querySelector('[data-ym="sessions-mount"]');
        if (sessionsMount) {
          sessionsMount.innerHTML = `
            <div class="ym-quiz__sessions" data-ym="sessions-widget">
              <div class="ym-quiz__sessions-title">
                <span class="ym-quiz__sessions-dot"></span>
                <span>${esc(window.__ymI18n('quiz.upsell2.sessions_title', "Prochaines sessions d'enregistrement"))}</span>
              </div>
              <div data-ym="sessions-list"></div>
            </div>`;
          this.renderSessionsWidget();
        }
      }

      // App blocks slot (reviews etc.) — rendered once by Liquid into the slot directly,
      // we just toggle visibility so app widget JS only initializes once and keeps its state.
      const afterSlot = document.querySelector('[data-ym="after-cta-slot"]');
      if (afterSlot) afterSlot.hidden = (this.currentStep !== 'upsell-2');

      this.bindStepBody();
      this.restoreStepValues();
    }

    /** Renders the urgency widget content (2 sessions with progress bars).
     *  Each row shows only the DELIVERY date (the recording date is implicit). */
    renderSessionsWidget() {
      const list = this.els.stepContent.querySelector('[data-ym="sessions-list"]');
      if (!list) return;
      const lang = this.listLocale;
      const i18n = {
        fr: {
          delivery: 'Livraison le', reserved: 'RÉSERVÉ',
          daysCap: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
          months: ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre']
        },
        en: {
          delivery: 'Delivery on', reserved: 'RESERVED',
          daysCap: ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
          months: ['January','February','March','April','May','June','July','August','September','October','November','December']
        },
        de: {
          delivery: 'Lieferung am', reserved: 'RESERVIERT',
          daysCap: ['Sonntag','Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag'],
          months: ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember']
        }
      };
      const t = i18n[lang] || i18n.fr;
      const now = new Date();
      const hh = now.getHours(), mm = now.getMinutes();
      // Delivery dates: today's session ships tomorrow; tomorrow's session ships day-after-tomorrow.
      const del1 = new Date(now); del1.setDate(del1.getDate() + 1);
      const del2 = new Date(now); del2.setDate(del2.getDate() + 2);
      const fmtDel = (d) => `${t.delivery} ${t.daysCap[d.getDay()]} ${d.getDate()} ${t.months[d.getMonth()]}`;

      // Percentages cap at 98% — never "complete". Today fills faster than tomorrow.
      const totalMin = hh * 60 + mm;
      const dayMin = 24 * 60;
      const pct1 = Math.min(98, Math.round(75 + (totalMin / dayMin) * 23));
      const pct2 = Math.min(98, Math.round(45 + (totalMin / dayMin) * 35));

      // Continuous color interpolation green -> yellow -> red based on percentage.
      const colorForPct = (p) => {
        const stops = [
          [0,   [42, 140, 90]],   // #2a8c5a green
          [50,  [234, 176, 8]],   // #eab308 yellow
          [100, [200, 74, 31]]    // #c84a1f red
        ];
        let lo = stops[0], hi = stops[stops.length - 1];
        for (let i = 0; i < stops.length - 1; i++) {
          if (p >= stops[i][0] && p <= stops[i + 1][0]) { lo = stops[i]; hi = stops[i + 1]; break; }
        }
        const range = hi[0] - lo[0];
        const tt = range === 0 ? 0 : (p - lo[0]) / range;
        const r = Math.round(lo[1][0] + (hi[1][0] - lo[1][0]) * tt);
        const g = Math.round(lo[1][1] + (hi[1][1] - lo[1][1]) * tt);
        const b = Math.round(lo[1][2] + (hi[1][2] - lo[1][2]) * tt);
        return `rgb(${r},${g},${b})`;
      };
      // Status badge tier (visual grouping for the badge color background) — distinct from bar fill color
      const tier = (p) => p >= 85 ? 'high' : (p >= 60 ? 'medium' : 'low');

      const item = (deliv, pct) => {
        const lvl = tier(pct);
        const status = `${pct}% ${t.reserved}`;
        const col = colorForPct(pct);
        // Inline !important on width + background to beat any theme CSS overrides
        const fillStyle = `width: ${pct}% !important; background-color: ${col} !important;`;
        return `
          <div class="ym-quiz__session">
            <div class="ym-quiz__session-row">
              <div class="ym-quiz__session-delivery-strong">${esc(fmtDel(deliv))}</div>
              <div class="ym-quiz__session-status ym-quiz__session-status--${lvl}">${esc(status)}</div>
            </div>
            <div class="ym-quiz__session-bar">
              <div class="ym-quiz__session-bar-fill" data-pct="${pct}" style="${fillStyle}"></div>
            </div>
          </div>`;
      };
      list.innerHTML = item(del1, pct1) + item(del2, pct2);

      // Defensive fallback: re-apply via cssText if inline style was somehow stripped
      const bars = list.querySelectorAll('.ym-quiz__session-bar-fill');
      const pcts = [pct1, pct2];
      bars.forEach((b, i) => {
        const p = pcts[i];
        const col = colorForPct(p);
        b.style.setProperty('width', p + '%', 'important');
        b.style.setProperty('background-color', col, 'important');
      });
    }

    refreshUpsell1Reveal() {
      const u = this.answers.upsell1;
      const root = this.els.stepContent;
      const container = root.querySelector('[data-ym-product-group]');
      const formSlot = root.querySelector('[data-ym="upsell1-form-slot"]');
      const socleRow = root.querySelector('[data-ym="upsell1-socle-row"]');
      const perso = root.querySelector('[data-ym="upsell1-perso"]');
      if (!socleRow || !perso || !formSlot || !container) return;

      // data-active drives CSS flex-order so the form sits between/under the right card
      container.dataset.active = u.product || '';

      if (u.product === 'plaque') {
        formSlot.hidden = false;
        socleRow.hidden = false;
        perso.hidden = false;
      } else if (u.product === 'magnet') {
        formSlot.hidden = false;
        socleRow.hidden = true;
        // Socle is plaque-only — clear if magnet picked
        this.answers.upsell1.socle = false;
        const cb = root.querySelector('[data-ym-field="upsell1Socle"]');
        if (cb) cb.checked = false;
        perso.hidden = false;
      } else {
        formSlot.hidden = true;
        socleRow.hidden = true;
        perso.hidden = true;
      }
    }

    /** Native HEIC decode via Canvas. iOS Safari/Chrome use the OS codec, so this works
     *  out-of-the-box on iPhones. Other platforms throw and the caller falls back to WASM. */
    _heicViaCanvas(file) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.decoding = 'async';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          if (!canvas.width || !canvas.height) {
            URL.revokeObjectURL(url);
            reject(new Error('Decoded image has zero size'));
            return;
          }
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          canvas.toBlob((blob) => {
            URL.revokeObjectURL(url);
            if (blob) resolve(blob);
            else reject(new Error('Canvas toBlob returned null'));
          }, 'image/jpeg', 0.85);
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          reject(new Error('Native HEIC decode not supported on this platform'));
        };
        img.src = url;
      });
    }

    /** Convert HEIC/HEIF file to JPEG. Tries native Canvas first (iOS), falls back to heic2any WASM. */
    async convertHeicToJpeg(file) {
      const baseName = (file.name || 'photo').replace(/\.(heic|heif)$/i, '') + '.jpg';
      // Try native Canvas decode first — works on iOS and macOS Safari natively
      try {
        const jpegBlob = await this._heicViaCanvas(file);
        return new File([jpegBlob], baseName, { type: 'image/jpeg' });
      } catch (canvasErr) {
        console.info('[ym-quiz] Canvas HEIC decode failed, trying heic2any WASM…', canvasErr.message);
      }
      // Fall back to heic2any (Android, desktop without HEIC support)
      await this.ensureHeic2Any();
      const result = await window.heic2any({ blob: file, toType: 'image/jpeg', quality: 0.85 });
      const jpegBlob = Array.isArray(result) ? result[0] : result;
      return new File([jpegBlob], baseName, { type: 'image/jpeg' });
    }

    /** Lazy-load a script with a fallback CDN if the primary fails (CSP, network…). */
    _loadScript(src) {
      return new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.crossOrigin = 'anonymous';
        s.onload = () => resolve();
        s.onerror = () => reject(new Error('Script load failed: ' + src));
        document.head.appendChild(s);
      });
    }

    /** Lazy-loads heic2any (~1MB) from jsDelivr; falls back to unpkg on failure. */
    ensureHeic2Any() {
      if (window.heic2any) return Promise.resolve();
      if (this._heic2anyPromise) return this._heic2anyPromise;
      this._heic2anyPromise = this._loadScript('https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js')
        .catch(() => this._loadScript('https://unpkg.com/heic2any@0.0.4/dist/heic2any.min.js'))
        .then(() => {
          if (!window.heic2any) throw new Error('heic2any loaded but undefined');
        });
      return this._heic2anyPromise;
    }

    async onPhotoSelected(ev) {
      const root = this.els.stepContent;
      const errEl = root.querySelector('[data-ym="photo-error"]');
      const preview = root.querySelector('[data-ym="photo-preview"]');
      let file = ev.target.files && ev.target.files[0];
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      if (!file) {
        this.photoFile = null;
        this.answers.upsell1.photoMeta = null;
        if (preview) preview.innerHTML = '<span>🖼</span>';
        this.updateNextEnabled();
        return;
      }

      // HEIC / HEIF (iPhone default since iOS 11): convert to JPEG in-browser.
      // Strategy: try the native Canvas decode FIRST (iOS Safari/Chrome use the OS HEIC codec).
      // If that fails (Android/desktop without HEIC support), fall back to heic2any WASM.
      const isHeic = /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name);
      const photoBtnLabel = root.querySelector('[data-ym="photo-btn-label"]');
      const originalBtnText = photoBtnLabel ? photoBtnLabel.textContent : '';
      if (isHeic) {
        const convertingMsg = this.listLocale === 'en' ? 'Converting iPhone photo…'
                            : this.listLocale === 'de' ? 'iPhone-Foto wird konvertiert…'
                            : 'Conversion de la photo iPhone…';
        if (photoBtnLabel) photoBtnLabel.textContent = convertingMsg;
        if (preview) preview.innerHTML = '<span style="font-size:22px;">⏳</span>';
        try {
          file = await this.convertHeicToJpeg(file);
          if (photoBtnLabel) photoBtnLabel.textContent = originalBtnText;
        } catch (e) {
          const detail = e && e.message ? ' (' + e.message + ')' : '';
          console.error('[ym-quiz] HEIC conversion failed:', e);
          if (photoBtnLabel) photoBtnLabel.textContent = originalBtnText;
          if (errEl) {
            const failMsg = this.listLocale === 'en'
              ? ('HEIC conversion failed' + detail + '. Try a screenshot or a JPG.')
              : this.listLocale === 'de'
              ? ('HEIC-Konvertierung fehlgeschlagen' + detail + '. Verwenden Sie einen Screenshot oder ein JPG.')
              : ('Conversion HEIC échouée' + detail + '. Essayez une capture d\'écran ou un JPG.');
            errEl.textContent = failMsg;
            errEl.hidden = false;
          }
          ev.target.value = '';
          if (preview) preview.innerHTML = '<span>🖼</span>';
          return;
        }
      }

      if (file.size > 20 * 1024 * 1024) {
        if (errEl) { errEl.textContent = window.__ymI18n('quiz.errors.photo_too_big', 'Photo trop volumineuse (max 20 Mo).'); errEl.hidden = false; }
        ev.target.value = '';
        if (preview) preview.innerHTML = '<span>🖼</span>';
        return;
      }
      if (!/^image\/(jpe?g|png|webp)$/i.test(file.type)) {
        if (errEl) { errEl.textContent = window.__ymI18n('quiz.errors.photo_wrong_type', 'Format non supporté. Utilisez JPG, PNG ou WEBP.'); errEl.hidden = false; }
        ev.target.value = '';
        if (preview) preview.innerHTML = '<span>🖼</span>';
        return;
      }
      this.photoFile = file;
      this.answers.upsell1.photoMeta = { name: file.name, size: file.size, type: file.type };
      this.save();
      const url = URL.createObjectURL(file);
      if (preview) preview.innerHTML = `<img src="${url}" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:8px;">`;
      this.updateNextEnabled();
    }

    /** Build the HTML for the current step's content area. */
    stepBodyHTML(step) {
      const t = (k, d) => window.__ymI18n(k, d);
      const lists = LISTS[this.listLocale] || LISTS.fr;

      if (step === 'step-1') {
        const recipients = window.__ymTree('step1.recipients') || {};
        const pills = RECIPIENT_KEYS
          .map(k => `<button type="button" class="ym-quiz__pill" data-ym-pill="${esc(k)}" data-ym-field="recipient">${esc(recipients[k] || k)}</button>`)
          .join('');
        return `
          <div class="ym-quiz__pills" data-ym-pill-group="recipient">${pills}</div>
          <div class="ym-quiz__other-reveal" data-ym-other-for="recipient" hidden>
            <p class="ym-quiz__field-label">${esc(t('quiz.step1.other_label','Précisez la relation'))}</p>
            <input type="text" class="ym-quiz__text-input" data-ym-field="recipientOther" placeholder="${esc(t('quiz.step1.other_placeholder','Ex. Mon parrain, ma belle-mère…'))}" maxlength="60">
          </div>
          <div>
            <p class="ym-quiz__field-label">${esc(t('quiz.step1.name_label','Son prénom'))}</p>
            <input type="text" class="ym-quiz__text-input" data-ym-field="recipientName" placeholder="${esc(t('quiz.step1.name_placeholder','Ex. Sophie'))}" maxlength="40">
          </div>`;
      }

      if (step === 'step-2') {
        const stylePills = lists.styles
          .map(s => `<button type="button" class="ym-quiz__pill" data-ym-pill="${esc(s)}" data-ym-field="musicStyle">${esc(s)}</button>`)
          .join('');
        const voicePills = lists.voices
          .map(v => `<button type="button" class="ym-quiz__pill" data-ym-pill="${esc(v)}" data-ym-field="voice">${esc(v)}</button>`)
          .join('');
        return `
          <p class="ym-quiz__field-label">${esc(t('quiz.step2.styles_label','Style'))}</p>
          <div class="ym-quiz__pills" data-ym-pill-group="musicStyle">${stylePills}</div>
          <div class="ym-quiz__other-reveal" data-ym-other-for="musicStyle" hidden>
            <p class="ym-quiz__field-label">${esc(t('quiz.step2.other_label','Précisez le style souhaité'))}</p>
            <input type="text" class="ym-quiz__text-input" data-ym-field="musicStyleOther" placeholder="${esc(t('quiz.step2.other_placeholder',''))}" maxlength="80">
          </div>
          <div>
            <p class="ym-quiz__field-label">${esc(t('quiz.step2.voice_label','Voix'))}</p>
            <div class="ym-quiz__pills" data-ym-pill-group="voice">${voicePills}</div>
          </div>`;
      }

      if (step === 'step-3') {
        const pills = lists.occasions
          .map(o => `<button type="button" class="ym-quiz__pill" data-ym-pill="${esc(o)}" data-ym-field="occasion">${esc(o)}</button>`)
          .join('');
        return `
          <div class="ym-quiz__pills" data-ym-pill-group="occasion">${pills}</div>
          <div class="ym-quiz__other-reveal" data-ym-other-for="occasion" hidden>
            <p class="ym-quiz__field-label">${esc(t('quiz.step3.other_label',"Précisez l'occasion"))}</p>
            <input type="text" class="ym-quiz__text-input" data-ym-field="occasionOther" placeholder="${esc(t('quiz.step3.other_placeholder',''))}" maxlength="80">
          </div>`;
      }

      // Steps 4-7: textarea
      const textareaSteps = {
        'step-4': { field: 'qualities', labelKey: 'quiz.step4.field_label', phKey: 'quiz.step4.placeholder' },
        'step-5': { field: 'memories',  labelKey: 'quiz.step5.field_label', phKey: 'quiz.step5.placeholder' },
        'step-6': { field: 'difficulties', labelKey: 'quiz.step6.field_label', phKey: 'quiz.step6.placeholder' },
        'step-7': { field: 'message',   labelKey: 'quiz.step7.field_label', phKey: 'quiz.step7.placeholder' }
      };
      if (textareaSteps[step]) {
        const cfg = textareaSteps[step];
        return `
          <p class="ym-quiz__field-label">${esc(t(cfg.labelKey,''))}</p>
          <div class="ym-quiz__textarea-wrap">
            <textarea class="ym-quiz__textarea" data-ym-field="${cfg.field}" placeholder="${esc(t(cfg.phKey,''))}" rows="6"></textarea>
          </div>`;
      }

      if (step === 'upsell-1') {
        const prods = window.__ymTree('upsell1.products') || { plaque: 'Plaque', magnet: 'Magnet' };
        const prices = this.prices || {};
        const lang = this.listLocale;
        const plaqueImg = this.images.plaque[lang] || this.images.plaque.fr || '';
        const magnetImg = this.images.magnet[lang] || this.images.magnet.fr || '';
        const card = (id, name, img, price) => `
          <button type="button" class="ym-quiz__product-card" data-ym-product="${esc(id)}" aria-pressed="false">
            <img class="ym-quiz__product-img" src="${esc(img)}" alt="${esc(name)}" loading="lazy">
            <div class="ym-quiz__product-info">
              <div class="ym-quiz__product-name">${esc(name)}</div>
              <div class="ym-quiz__product-price">${price ? esc(price) : ''}</div>
            </div>
          </button>`;
        // Form slot sits BETWEEN the two cards. CSS flex order moves it after Magnet when Magnet is selected.
        return `
          <div class="ym-quiz__products" data-ym-product-group data-active="">
            ${card('plaque', prods.plaque, plaqueImg, prices.plaque)}
            <div class="ym-quiz__form-slot" data-ym="upsell1-form-slot" hidden>
              <div class="ym-quiz__form-slot-arrow" aria-hidden="true"></div>

          <label class="ym-quiz__socle" data-ym="upsell1-socle-row" hidden>
            <input type="checkbox" data-ym-field="upsell1Socle">
            <span>${esc(t('quiz.upsell1.socle_label','Ajouter un socle en bois'))}</span>
            <span class="ym-quiz__socle-price" data-ym="socle-price">${esc(prices.socle || '')}</span>
          </label>

          <div class="ym-quiz__perso" data-ym="upsell1-perso" hidden>
            <div>
              <p class="ym-quiz__field-label">${esc(t('quiz.upsell1.perso_title_label','Titre de la chanson'))} <span class="ym-quiz__req">*</span></p>
              <div class="ym-quiz__input-wrap">
                <input type="text" class="ym-quiz__text-input" data-ym-field="upsell1SongTitle" maxlength="40" placeholder="${esc(t('quiz.upsell1.perso_title_placeholder',''))}">
                <span class="ym-quiz__char-counter" data-ym-counter-for="upsell1SongTitle">0/40</span>
              </div>
              <p class="ym-quiz__field-help">${esc(t('quiz.upsell1.perso_title_max','40 caractères maximum'))}</p>
            </div>

            <div>
              <p class="ym-quiz__field-label">${esc(t('quiz.upsell1.perso_artist_label','Artiste'))} <span class="ym-quiz__req">*</span></p>
              <div class="ym-quiz__input-wrap">
                <input type="text" class="ym-quiz__text-input" data-ym-field="upsell1Artist" maxlength="30" placeholder="${esc(t('quiz.upsell1.perso_artist_placeholder',''))}">
                <span class="ym-quiz__char-counter" data-ym-counter-for="upsell1Artist">0/30</span>
              </div>
              <p class="ym-quiz__field-help">${esc(t('quiz.upsell1.perso_artist_max','30 caractères maximum'))}</p>
            </div>

            <div>
              <p class="ym-quiz__field-label">${esc(t('quiz.upsell1.perso_photo_label','Photo de couverture'))} <span class="ym-quiz__req">*</span></p>
              <div class="ym-quiz__photo-row">
                <div class="ym-quiz__photo-preview" data-ym="photo-preview"><span>🖼</span></div>
                <label class="ym-quiz__photo-btn">
                  <span data-ym="photo-btn-label">${esc(t('quiz.upsell1.perso_photo_btn','Choisissez une photo'))}</span>
                  <input type="file" data-ym="photo-input" accept="image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif" hidden>
                </label>
              </div>
              ${t('quiz.upsell1.perso_photo_help','') ? `<p class="ym-quiz__field-help">${esc(t('quiz.upsell1.perso_photo_help',''))}</p>` : ''}
              <p class="ym-quiz__field-error" data-ym="photo-error" hidden></p>
            </div>
          </div>
            </div>
            ${card('magnet', prods.magnet, magnetImg, prices.magnet)}
          </div>
        `;
      }

      if (step === 'upsell-2') {
        const prices = this.prices || {};
        const expressPrice = prices.express ? '+ ' + esc(prices.express) : '+11,90 €';
        const streamingPrice = prices.streaming ? '+ ' + esc(prices.streaming) : '+24,90 €';
        return `
          <p class="ym-quiz__field-label">${esc(t('quiz.upsell2.delivery_label','Livraison de la chanson'))}</p>

          <label class="ym-quiz__delivery">
            <input type="radio" name="ym-delivery" data-ym-field="upsell2Delivery" value="standard" checked>
            <div class="ym-quiz__delivery-info">
              <div class="ym-quiz__delivery-name">${esc(t('quiz.upsell2.delivery_standard_name','Standard'))}</div>
              <div class="ym-quiz__delivery-meta">${esc(t('quiz.upsell2.delivery_standard_meta','Sous 48h · par email'))}</div>
            </div>
            <div class="ym-quiz__delivery-price ym-quiz__delivery-price--free">${esc(t('quiz.upsell2.delivery_standard_price','Gratuit'))}</div>
          </label>

          <label class="ym-quiz__delivery">
            <input type="radio" name="ym-delivery" data-ym-field="upsell2Delivery" value="express">
            <div class="ym-quiz__delivery-info">
              <div class="ym-quiz__delivery-name">${esc(t('quiz.upsell2.delivery_express_name','Express'))}</div>
              <div class="ym-quiz__delivery-meta">${esc(t('quiz.upsell2.delivery_express_meta','Sous 24h · prioritaire'))}</div>
            </div>
            <div class="ym-quiz__delivery-price">${expressPrice}</div>
          </label>

          <div data-ym="sessions-mount"></div>

          <p class="ym-quiz__field-label">${esc(t('quiz.upsell2.diffusion_label','Diffusion'))}</p>

          <label class="ym-quiz__delivery">
            <input type="checkbox" data-ym-field="upsell2Streaming">
            <div class="ym-quiz__delivery-info">
              <div class="ym-quiz__delivery-name">${esc(t('quiz.upsell2.streaming_name','Streaming Spotify & Apple Music'))}</div>
              <div class="ym-quiz__delivery-meta">${esc(t('quiz.upsell2.streaming_meta','Votre chanson sur les plateformes'))}</div>
            </div>
            <div class="ym-quiz__delivery-price">${streamingPrice}</div>
          </label>
        `;
      }

      return `<p style="text-align:center;color:#888;padding:40px 0;">${esc(step)}</p>`;
    }

    /** Bind input/click events for the just-rendered step body. */
    bindStepBody() {
      const root = this.els.stepContent;
      // Pills
      root.querySelectorAll('.ym-quiz__pill').forEach(btn => {
        btn.addEventListener('click', () => {
          const field = btn.dataset.ymField;
          const value = btn.dataset.ymPill;
          const group = btn.closest('.ym-quiz__pills');
          if (group) {
            group.querySelectorAll('.ym-quiz__pill').forEach(b => b.setAttribute('aria-pressed', 'false'));
            btn.setAttribute('aria-pressed', 'true');
          }
          this.answers[field] = value;
          // Reveal/hide "Other" text input
          const other = root.querySelector('[data-ym-other-for="' + field + '"]');
          if (other) other.hidden = !isOtherValue(value);
          this.save();
          this.updateNextEnabled();
        });
      });
      // Text inputs + textareas (generic — exclude special upsell fields handled below)
      root.querySelectorAll('[data-ym-field]:not(.ym-quiz__pill)').forEach(el => {
        const field = el.dataset.ymField;
        // Skip fields handled by upsell-specific bindings below
        if (['upsell1Socle','upsell1SongTitle','upsell1Artist','upsell2Delivery','upsell2Streaming'].includes(field)) return;
        el.addEventListener('input', () => {
          this.answers[field] = el.value;
          this.save();
          this.updateNextEnabled();
        });
      });

      // --- Upsell 1 bindings ---
      if (this.currentStep === 'upsell-1') {
        // Product card selection (toggle)
        root.querySelectorAll('[data-ym-product]').forEach(card => {
          card.addEventListener('click', () => {
            const id = card.dataset.ymProduct;
            const wasActive = card.getAttribute('aria-pressed') === 'true';
            // Clear all
            root.querySelectorAll('[data-ym-product]').forEach(c => c.setAttribute('aria-pressed', 'false'));
            if (!wasActive) {
              card.setAttribute('aria-pressed', 'true');
              this.answers.upsell1.product = id;
            } else {
              this.answers.upsell1.product = null;
            }
            this.save();
            this.refreshUpsell1Reveal();
            this.updateNextEnabled();
          });
        });

        const socleCb = root.querySelector('[data-ym-field="upsell1Socle"]');
        if (socleCb) {
          socleCb.addEventListener('change', () => {
            this.answers.upsell1.socle = socleCb.checked;
            this.save();
          });
        }

        ['upsell1SongTitle','upsell1Artist'].forEach(field => {
          const input = root.querySelector('[data-ym-field="' + field + '"]');
          if (!input) return;
          const counter = root.querySelector('[data-ym-counter-for="' + field + '"]');
          const key = field === 'upsell1SongTitle' ? 'songTitle' : 'artist';
          input.addEventListener('input', () => {
            this.answers.upsell1[key] = input.value;
            if (counter) counter.textContent = `${input.value.length}/${input.maxLength}`;
            this.save();
            this.updateNextEnabled();
          });
        });

        const fileInput = root.querySelector('[data-ym="photo-input"]');
        if (fileInput) fileInput.addEventListener('change', (ev) => this.onPhotoSelected(ev));
      }

      // --- Upsell 2 bindings ---
      if (this.currentStep === 'upsell-2') {
        root.querySelectorAll('[name="ym-delivery"]').forEach(r => {
          r.addEventListener('change', () => {
            if (r.checked) {
              this.answers.upsell2.delivery = r.value;
              this.save();
            }
          });
        });
        const streamCb = root.querySelector('[data-ym-field="upsell2Streaming"]');
        if (streamCb) {
          streamCb.addEventListener('change', () => {
            this.answers.upsell2.streaming = streamCb.checked;
            this.save();
          });
        }
      }
    }

    restoreStepValues() {
      const root = this.els.stepContent;
      root.querySelectorAll('.ym-quiz__pill').forEach(btn => {
        const field = btn.dataset.ymField;
        const value = btn.dataset.ymPill;
        if (this.answers[field] === value) {
          btn.setAttribute('aria-pressed', 'true');
          if (isOtherValue(value)) {
            const other = root.querySelector('[data-ym-other-for="' + field + '"]');
            if (other) other.hidden = false;
          }
        }
      });
      root.querySelectorAll('[data-ym-field]:not(.ym-quiz__pill)').forEach(el => {
        const field = el.dataset.ymField;
        // Skip upsell-specific fields — restored below
        if (['upsell1Socle','upsell1SongTitle','upsell1Artist','upsell2Delivery','upsell2Streaming'].includes(field)) return;
        const v = this.answers[field];
        if (v != null) el.value = v;
      });

      // --- Upsell 1 restore ---
      if (this.currentStep === 'upsell-1') {
        const u = this.answers.upsell1;
        root.querySelectorAll('[data-ym-product]').forEach(card => {
          if (card.dataset.ymProduct === u.product) {
            card.setAttribute('aria-pressed', 'true');
          }
        });
        const socleCb = root.querySelector('[data-ym-field="upsell1Socle"]');
        if (socleCb) socleCb.checked = !!u.socle;
        const titleInput = root.querySelector('[data-ym-field="upsell1SongTitle"]');
        if (titleInput) {
          titleInput.value = u.songTitle || '';
          const c = root.querySelector('[data-ym-counter-for="upsell1SongTitle"]');
          if (c) c.textContent = `${titleInput.value.length}/40`;
        }
        const artistInput = root.querySelector('[data-ym-field="upsell1Artist"]');
        if (artistInput) {
          artistInput.value = u.artist || '';
          const c = root.querySelector('[data-ym-counter-for="upsell1Artist"]');
          if (c) c.textContent = `${artistInput.value.length}/30`;
        }
        this.refreshUpsell1Reveal();
      }

      // --- Upsell 2 restore ---
      if (this.currentStep === 'upsell-2') {
        const u = this.answers.upsell2;
        root.querySelectorAll('[name="ym-delivery"]').forEach(r => {
          r.checked = (r.value === (u.delivery || 'standard'));
        });
        const streamCb = root.querySelector('[data-ym-field="upsell2Streaming"]');
        if (streamCb) streamCb.checked = !!u.streaming;
      }
    }

    updateNextEnabled() {
      let ok = true;
      const a = this.answers;
      switch (this.currentStep) {
        case 'step-1':
          ok = !!a.recipient && !!a.recipientName && a.recipientName.trim().length > 0;
          if (ok && a.recipient === 'other') {
            ok = !!a.recipientOther && a.recipientOther.trim().length > 0;
          }
          break;
        case 'step-2':
          ok = !!a.musicStyle && !!a.voice;
          if (ok && isOtherValue(a.musicStyle)) {
            ok = !!a.musicStyleOther && a.musicStyleOther.trim().length > 0;
          }
          break;
        case 'step-3':
          ok = !!a.occasion;
          if (ok && isOtherValue(a.occasion)) {
            ok = !!a.occasionOther && a.occasionOther.trim().length > 0;
          }
          break;
        case 'step-4':
        case 'step-5':
        case 'step-6':
        case 'step-7':
          ok = true;
          break;
        case 'upsell-1': {
          const u = a.upsell1;
          if (u.product === null) { ok = true; break; } // "Aucun" or none — valid
          const titleOK = !!u.songTitle && u.songTitle.trim().length > 0;
          const artistOK = !!u.artist && u.artist.trim().length > 0;
          const photoOK = !!this.photoFile;
          ok = titleOK && artistOK && photoOK;
          break;
        }
        case 'upsell-2':
          ok = true;
          break;
        default:
          ok = true;
      }
      this.els.btnNext.disabled = !ok;
    }

    // ============================================================
    //  Cart submission (Phase 9)
    // ============================================================

    /** Resolve recipient slug → localized label, with "Autre" override. */
    resolveRecipient() {
      const a = this.answers;
      if (a.recipient === 'other') {
        return (a.recipientOther || '').trim() || 'Autre';
      }
      const recipients = window.__ymTree('step1.recipients') || {};
      return recipients[a.recipient] || a.recipient || '';
    }

    /** Resolve style/occasion with "Autre" override. */
    resolveWithOther(value, otherText) {
      if (!value) return '';
      if (isOtherValue(value)) return (otherText || '').trim() || value;
      return value;
    }

    /** Build line item properties dict for the SONG product. Labels are localized. */
    buildSongProperties() {
      const a = this.answers;
      const L = PROP_LABELS[this.listLocale] || PROP_LABELS.fr;
      const props = {};
      props[L.recipient]    = flatten(this.resolveRecipient());
      props[L.firstName]    = flatten(a.recipientName);
      props[L.style]        = flatten(this.resolveWithOther(a.musicStyle, a.musicStyleOther));
      props[L.voice]        = flatten(a.voice);
      props[L.occasion]     = flatten(this.resolveWithOther(a.occasion, a.occasionOther));
      props[L.qualities]    = flatten(a.qualities);
      props[L.memories]     = flatten(a.memories);
      props[L.difficulties] = flatten(a.difficulties);
      props[L.message]      = flatten(a.message);
      // Hidden meta (underscore-prefixed = invisible to customer in cart/checkout, visible to merchant in admin)
      props['_locale']        = this.locale;
      props['_quiz_version']  = 'v1';
      // Drop empty optional textareas
      [L.qualities, L.memories, L.difficulties, L.message].forEach(k => { if (!props[k]) delete props[k]; });
      return props;
    }

    /** Build line item properties dict for the PLAQUE/MAGNET physical product. Labels are localized. */
    buildPhysicalProperties() {
      const u = this.answers.upsell1;
      const L = PROP_LABELS[this.listLocale] || PROP_LABELS.fr;
      const props = {};
      props[L.songTitle] = flatten(u.songTitle);
      props[L.artist]    = flatten(u.artist);
      if (u.product === 'plaque' && u.socle) {
        props[L.socle] = L.yes;
      }
      return props;
    }

    /** Multipart POST to /cart/add.js — uploads the photo File AND adds the physical product to cart in one call. */
    async uploadPhotoForVariant(variantId, extraProps) {
      const fd = new FormData();
      fd.append('id', String(variantId));
      fd.append('quantity', '1');
      Object.entries(extraProps || {}).forEach(([k, v]) => {
        if (v !== null && v !== undefined && String(v).length > 0) {
          fd.append('properties[' + k + ']', String(v));
        }
      });
      fd.append('properties[Photo]', this.photoFile, this.photoFile.name);
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' }
      });
      if (!resp.ok) {
        const text = await resp.text();
        throw new Error('Photo upload failed (' + resp.status + '): ' + text.slice(0, 200));
      }
      return resp.json();
    }

    /** Display an error message under the button row. Creates the element if missing. */
    showSubmitError(message) {
      const btnRow = this.root.querySelector('.ym-quiz__button-row');
      if (!btnRow) return;
      let err = this.root.querySelector('[data-ym="submit-error"]');
      if (!err) {
        err = document.createElement('p');
        err.setAttribute('data-ym', 'submit-error');
        err.className = 'ym-quiz__submit-error';
        btnRow.parentElement.insertBefore(err, btnRow.nextSibling);
      }
      err.textContent = message;
      err.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    clearSubmitError() {
      const err = this.root.querySelector('[data-ym="submit-error"]');
      if (err) err.remove();
    }

    /** Orchestrates: photo upload (if applicable) → JSON batch add → redirect to /checkout. */
    async submit() {
      const btnNext = this.els.btnNext;
      const labelEl = btnNext.querySelector('span:not([aria-hidden])');
      const originalLabel = labelEl ? labelEl.textContent : '';
      btnNext.disabled = true;
      btnNext.classList.add('ym-quiz__btn--loading');
      const hasPhoto = !!(this.answers.upsell1.product && this.photoFile);
      if (labelEl) labelEl.textContent = hasPhoto
        ? (this.locale.startsWith('en') ? 'Uploading your photo…' : this.locale.startsWith('de') ? 'Foto wird hochgeladen…' : 'Téléversement de votre photo…')
        : (this.locale.startsWith('en') ? 'Preparing your order…' : this.locale.startsWith('de') ? 'Bestellung wird vorbereitet…' : 'Préparation de votre commande…');
      this.clearSubmitError();

      try {
        // Sanity check: all required variant IDs must be valid numbers
        const variantIdValid = (v) => v && !isNaN(Number(v)) && Number(v) > 0;
        if (!variantIdValid(this.variants.song)) {
          throw new Error('Variant ID manquant pour la chanson (vérifier les settings de la section)');
        }

        const u1 = this.answers.upsell1;
        const u2 = this.answers.upsell2;
        const songProps = this.buildSongProperties();
        const physicalProps = this.buildPhysicalProperties();

        // 1. If a physical product + photo were chosen, do the multipart upload first
        if (u1.product && this.photoFile) {
          const physicalVariantId = u1.product === 'plaque' ? this.variants.plaque : this.variants.magnet;
          if (!variantIdValid(physicalVariantId)) {
            throw new Error('Variant ID manquant pour ' + u1.product);
          }
          await this.uploadPhotoForVariant(Number(physicalVariantId), physicalProps);
        }

        // 2. Build JSON items array for the rest
        const items = [
          { id: Number(this.variants.song), quantity: 1, properties: songProps }
        ];
        if (u1.product === 'plaque' && u1.socle && variantIdValid(this.variants.socle)) {
          items.push({ id: Number(this.variants.socle), quantity: 1 });
        }
        if (u2.delivery === 'express' && variantIdValid(this.variants.express)) {
          items.push({ id: Number(this.variants.express), quantity: 1 });
        }
        if (u2.streaming && variantIdValid(this.variants.streaming)) {
          items.push({ id: Number(this.variants.streaming), quantity: 1 });
        }

        // 3. JSON batch add — atomic on Shopify's side (all-or-nothing for this call)
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!resp.ok) {
          const text = await resp.text();
          throw new Error('Échec ajout panier (' + resp.status + '): ' + text.slice(0, 300));
        }

        // Shopify's native pixel fires AddToCart + InitiateCheckout automatically.
        // We do NOT duplicate them here. Quiz-specific funnel events fire from next() / step transitions.

        // 5. Clear quiz state and redirect to checkout
        this.clear();
        window.location.href = '/checkout';

      } catch (err) {
        console.error('[ym-quiz] submit error', err);
        btnNext.disabled = false;
        btnNext.classList.remove('ym-quiz__btn--loading');
        if (labelEl) labelEl.textContent = originalLabel;
        const msg = window.__ymI18n('quiz.errors.cart_failed', 'Une erreur est survenue. Vérifiez votre connexion et réessayez.');
        const detail = (err && err.message) ? '\n(' + err.message + ')' : '';
        this.showSubmitError(msg + detail);
      }
    }

    bind() {
      this.els.btnBack.addEventListener('click', () => this.back());
      this.els.btnNext.addEventListener('click', () => this.next());
      window.addEventListener('hashchange', () => {
        const target = window.location.hash.slice(1);
        if (STEPS.includes(target) && target !== this.currentStep) {
          this.goto(target, { silent: true });
        }
      });
    }

    start() {
      this.load();
      const hashStep = window.location.hash.slice(1);
      if (STEPS.includes(hashStep)) this.currentStep = hashStep;
      this.bind();
      this.render();
      // Fire arrival event for the initial step (fresh visit OR resumed session)
      this.trackArrival(this.currentStep);
    }
  }

  function init() {
    const root = document.getElementById('ym-quiz');
    if (!root) return;
    window.__ymQuiz = new YMQuiz(root);
    window.__ymQuiz.start();
    console.info('[ym-quiz] initialized · locale=' + window.__ymQuiz.locale);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
